import React__default from 'react';
import { Typography } from '@vp/swan';

var EM_TAG_PLACEHOLDER = 'EM_TAG_PLACEHOLDER';
var END_EM_TAG_PLACEHOLDER = 'END_EM_TAG_PLACEHOLDER';
var ResultText = function ResultText(_ref) {
  var resultText = _ref.resultText;
  if (!resultText) return null;
  if (resultText.indexOf('ais-highlight-0000000000') !== -1) {
    resultText = resultText.replace('ais-highlight-0000000000', 'em');
  }
  if (resultText.indexOf('<em>') === -1) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, resultText);
  var chunks = [];
  var beginTag = true;
  var nextTagIndex = 0;
  while (resultText.length > 0) {
    if (beginTag) {
      nextTagIndex = resultText.indexOf('<em>');
    } else {
      nextTagIndex = resultText.indexOf('</em>');
    }
    if (nextTagIndex === -1) {
      chunks.push(resultText);
      break;
    }
    if (beginTag) {
      chunks.push(resultText.substring(0, nextTagIndex));
      chunks.push(EM_TAG_PLACEHOLDER);
      resultText = resultText.slice(nextTagIndex + 4);
    } else {
      chunks.push(resultText.substring(0, nextTagIndex));
      chunks.push(END_EM_TAG_PLACEHOLDER);
      resultText = resultText.slice(nextTagIndex + 5);
    }
    beginTag = !beginTag;
  }
  beginTag = false;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, chunks.map(function (chunk, index) {
    if (chunk === EM_TAG_PLACEHOLDER) {
      beginTag = true;
      return;
    }
    if (chunk === END_EM_TAG_PLACEHOLDER) {
      beginTag = false;
      return;
    }
    if (beginTag) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        as: "mark",
        fontWeight: "bold",
        backgroundColor: "transparent",
        key: chunk + index,
        color: "standard"
      }, chunk);
    } else {
      return chunk;
    }
  }));
};

export { ResultText as default };
//# sourceMappingURL=ResultText.js.map
